import { render, staticRenderFns } from "./checkout-label.vue?vue&type=template&id=6c9376a7&"
import script from "./checkout-label.vue?vue&type=script&lang=js&"
export * from "./checkout-label.vue?vue&type=script&lang=js&"
import style0 from "./checkout-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9376a7')) {
      api.createRecord('6c9376a7', component.options)
    } else {
      api.reload('6c9376a7', component.options)
    }
    module.hot.accept("./checkout-label.vue?vue&type=template&id=6c9376a7&", function () {
      api.rerender('6c9376a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-label.vue"
export default component.exports